import {
    FormField,
    TActiveIntegrationTypes,
    TIntegrationEnabledMapping,
} from '../modules/integrations/integrations'

export const useIntegrations = () => {
    const integrationsMapping: TIntegrationEnabledMapping = {
        google: true,
        microsoft: true,
        crowdstrike: true,
        ms_fraud_defense: true,
        google_fraud_defense: true,
    }

    const formStructure: {
        [K in TActiveIntegrationTypes]: FormField[]
    } = {
        google: [],
        microsoft: [],
        crowdstrike: [
            { type: 'text', label: 'client_id', name: 'Client ID' },
            { type: 'password', label: 'client_secret', name: 'Client Secret' },
            { type: 'text', label: 'base_url', name: 'Base URL' },
        ],
        ms_fraud_defense: [],
        google_fraud_defense: [],
    }

    const hasEnabledIntegrations = Object.values(integrationsMapping).some(
        (isEnabled) => isEnabled
    )

    return {
        integrationsMapping,
        hasEnabledIntegrations,
        formStructure,
    }
}
